/* istanbul ignore file */
export default
`<div ref="printRef">
    <div :id="'layoutContainer_' + templateUniqueId" class="layout-container" :class="containerClasses" :style="containerStyles">
        <div class="header-content" :class="headerClasses" :style="headerStyles" ref="headerContent" v-if="settings.enableHeader">
            <div class="header-top-row">
                <div class="header-logo" v-if="settings.headerLogoImage">
                    <img :src="settings.headerLogoImage" :style="headerLogoStyles" :alt="settings.headerLogoAltText" :title="settings.headerLogoTitle"/>
                </div>
                <div class="header-text">
                    <component :is="{template: '<div>' + settings.header + '</div>', props:{user: {default: false}}}" :user="user" />
                </div>
                <div class="header-components">
                    <div v-if="positionsFiltered[0]" v-for="(component, index) in positionsFiltered[0].components" :key="component.cId">
                        <component 
                            v-bind="componentMappedProps[component.cId.split('__')[0]]" 
                            :is="component.cType" 
                            :cId="component.cId" 
                            :editor-enabled="editorEnabled"
                            v-if="displayedComponents[component.cId]" 
                            v-show="showedComponents[component.cId]" 
                            :unique-store-id="uniqueStoreId"
                            class="layout-component"
                            :ref="'ref__' + component.cId"
                        ></component>
                    </div>
                </div>
            </div>
            <p v-if="settings.headerMessage">{{settings.headerMessage}}</p>
        </div>
        <div class="layout-content" ref="layoutContent">
            <ejs-splitter :id="'mainSplitter_' + templateUniqueId" height="100%" separatorSize="3" orientation="Vertical" ref="splitter" v-on:collapsed="expandCollapse($event,'collapse')"  v-on:expanded="expandCollapse($event,'expand')">
                <e-panes>
                    <e-pane :content="'#topRow_' + templateUniqueId" size="50%" :collapsible="splitterCollapsible" :collapsed="pane0Collapsed"></e-pane>
                    <e-pane :content="'#bottomRow_' + templateUniqueId" :collapsible="splitterCollapsible" :collapsed="pane1Collapsed"></e-pane>
                </e-panes>
            </ejs-splitter>
            <div :id="'topRow_' + templateUniqueId" :class="splitPaneClasses.topRow">
                <div v-if="!hideComponents.pane0 || (hideComponents.pane0 && !pane0Collapsed)">
                    <div v-if="positionsFiltered[1]" v-for="(component, index) in positionsFiltered[1].components" :key="component.cId" style="height: 100%; width: 100%">
                        <component 
                            v-bind="componentMappedProps[component.cId.split('__')[0]]"
                            :is="component.cType" 
                            :cId="component.cId" 
                            :editor-enabled="editorEnabled" 
                            v-if="displayedComponents[component.cId]" 
                            v-show="showedComponents[component.cId]" 
                            class="layout-component"
                            :ref="'ref__' + component.cId"
                        ></component>
                    </div>
                </div>
            </div>
            <div :id="'bottomRow_' + templateUniqueId" :class="splitPaneClasses.bottomRow">
                <div v-if="!hideComponents.pane1 || (hideComponents.pane1 && !pane1Collapsed)">
                    <div v-if="positionsFiltered[2]" v-for="(component, index) in positionsFiltered[2].components" :key="component.cId" style="height: 100%; width: 100%">
                        <component 
                            v-bind="componentMappedProps[component.cId.split('__')[0]]"
                            :is="component.cType" 
                            :cId="component.cId" 
                            :editor-enabled="editorEnabled" 
                            v-if="displayedComponents[component.cId]" 
                            v-show="showedComponents[component.cId]" 
                            class="layout-component"
                            :ref="'ref__' + component.cId"
                        ></component>
                    </div>
                </div>
            </div>
        </div>
        <div class="footer-content" ref="footerContent" v-if="settings.enableFooter">
            <div v-if="positionsFiltered[3]" v-for="(component, index) in positionsFiltered[3].components" :key="component.cId" style="height: 100%; width: 100%">
                <component 
                    v-bind="componentMappedProps[component.cId.split('__')[0]]" 
                    :is="component.cType" 
                    :cId="component.cId" 
                    :editor-enabled="editorEnabled"
                    v-if="displayedComponents[component.cId]" 
                    v-show="showedComponents[component.cId]" 
                    :unique-store-id="uniqueStoreId"
                    class="layout-component"
                    :ref="'ref__' + component.cId"
                ></component>
            </div>
        </div>
    </div>
</div>`;
